import styled from 'styled-components';
import Colors from '../../constants/Colors';
import { FontWeight, Text } from '../Text';
import { Breakpoints } from '../../constants/Breakpoints';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  height: 68px;
  background: ${Colors.GRAY[7]};

  @media (min-width: ${Breakpoints.sm}) {
    position: sticky;
    top: 0;
    z-index: 100;
  }
`;

export const MenuContent = styled.div`
${({ projectName }) => projectName ? `width: 220px` : 'width: 100px'}
  /* width: 100px; */
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  @media (max-width: ${Breakpoints.sm}) {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 16px;
  }
`;

export const UserContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  width: 20%;
  height: 100%;
  padding-right: 24px;

  cursor: pointer;
`;

export const Profile = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  min-width: 52px;
  height: 52px;
  background-color: white;
  border-radius: 50px;
  align-items: center;
  justify-content: center;
`;

export const IconNotification = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: red;
  color: ${Colors.WHITE};
  border-radius: 12px;
  font-size: 12px;
  font-weight: ${FontWeight.ExtraBold};
  width: 22px;
  height: 22px;
  position: absolute;
  top: 34px;
  left: 36px;
  cursor: pointer;
`;

export const IconCheckContainer = styled.div`
  width: 26px;
  position: absolute;
  top: 32px;
  left: 36px;
`;

export const NameContent = styled.div`
  display: none;

  @media (min-width: ${Breakpoints.xxl}) {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
  }
`;

export const Name = styled(Text)`
  font-size: 15px;
  font-weight: ${FontWeight.ExtraBold};
  color: ${Colors.GRAY[6]};
`;

export const Country = styled(Text)`
  font-size: 15px;
  font-weight: ${FontWeight.Regular};
  color: ${Colors.GRAY[6]};
`;

export const EnvironmentAlert = styled.div`
  font-size: 16px;
  text-align: center;
  font-weight: ${FontWeight.ExtraBold};
  color: ${Colors.GRAY[6]};

  @media (max-width: ${Breakpoints.sm}) {
    display: none;
  }
`;

export const EnvironmentAlertMobile = styled.div`
  width: 100vw;
  font-size: 16px;
  text-align: center;
  background: ${Colors.GRAY[7]};
  font-weight: ${FontWeight.ExtraBold};
  color: ${Colors.GRAY[6]};

  @media (min-width: ${Breakpoints.sm}) {
    display: none;
  }
`;